export function clearCache() {
  if ('caches' in window) {
    // eslint-disable-next-line promise/prefer-await-to-then
    caches.keys().then(async (cacheNames: string[]) => {
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
      console.debug('Service worker cache cleared successfully.');
    });
  }
}
